import { useFuelStocks } from '../../../vessel/VesselDetailPage/FuelStocks/hooks/useFuelStocks';

import { useFormikEffect } from './useFormikEffect';

export const useFuelStocksPrefetching = (name) => {
    const { prefetch } = useFuelStocks();

    useFormikEffect(prefetch, name);
};
